import $ from 'jquery';
import Clipboard from 'clipboard';

const $shareMore = $('.js-share-more');
const $shareList = $('.js-share-list');

function share( el ) {
  addClickHandlers();
  addDocumentListener();
  initClipboard();
}

function addClickHandlers(){
  $('.js-share').on( 'click', (e) => {
    e.preventDefault();
    showPopup( e.currentTarget.href );
  });

  $shareMore.on( 'click', (e) => {
    $(e.currentTarget).next().fadeIn(100, function() {
      $(this).addClass('js-share-open');
    });

  });
}

function addDocumentListener(){
  $(document).on('click touchstart', function (event) {
    if(!$(event.target).closest($shareMore).length && !$(event.target).closest($shareList).length) {
      if($shareList.is(":visible")) {
        $shareList.fadeOut(100, function() {
          $(this).removeClass('js-share-open');
        });
      }
    }
  });
}

function showPopup( url ) {
  let width = 800;
  let height = 550;
  let top = (($(window).height() / 2) - (height / 2));
  let left = (($(window).width() / 2) - (width / 2));
  let opts = `width=${width}, height=${height}, top=${top}, left=${left}, toolbar=0, location=0, menubar=0, directories=0, scrollbars=0`;

  window.open(url, 'shareWindow', opts);
}

function initClipboard(){
    let clipboard = new Clipboard('.share__copy-to-clipboard');
    let $copyBtn = $('.share__copy-to-clipboard');

    clipboard.on('success', function(e) {
      $copyBtn.text('Copied!');
      setTimeout(function(){
        $copyBtn.text('Copy URL');
        $copyBtn.blur();
      }, 3000);
      e.clearSelection();
    });

    clipboard.on('error', function(e) {
      $copyBtn.text('Not Supported');
      setTimeout(function(){
        $copyBtn.addClass('share__copy-to-clipboard--disabled');
        $copyBtn.blur();
      }, 3000);
    });
}

export default share;
